export const formatAmount = (amount: number) => {
  return Intl.NumberFormat("en", {
    notation: "compact",
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  }).format(amount);
};
